import React, { createContext, useEffect } from "react";

const ApplicationContext = createContext();
ApplicationContext.displayName = "ApplicationContext";
export default ApplicationContext;

export const ApplicationProvider = (props) => {
  // const [floorsReady, setFloorsReadyState] = useState(false);
  // const [physiciansReady, setPhysiciansReadyState] = useState(false);
  // const [servicesReady, setServicesReadState] = useState(false);

  // On first mount, fetch data from the API's.
  useEffect(() => {
    // fetchFloors();
    // fetchPhysicians();
    // fetchServices();
  }, []);

  // Wrapping the set state functions used by the context with a simple logging function that will log the context values to the console
  // when the setter functions are called to set state and the application is in debugMode.
  // const setFloorList = connectLogger(
  //   setFloorListState,
  //   "ApplicationContext::floorList"
  // );

  /**
   * Retrieves a list of Floors from the API to populate a drop down list.
   * @param {String} query Stringified JSON object containing API query definition.
   */

  // The isReady context property is used to indicate that all three core application services have retrieved data and set the application context appropriately
  // const isReady = floorsReady && physiciansReady && servicesReady;
  const isReady = true;
  return (
    <ApplicationContext.Provider
      value={{
        isReady,
      }}
    >
      {props.children}
    </ApplicationContext.Provider>
  );
};
